/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  fixDecoderSize,
  fixEncoderSize,
  getBytesDecoder,
  getBytesEncoder,
  getStructDecoder,
  getStructEncoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
  type ReadonlyUint8Array,
} from '@solana/kit';

/**
 * Arguments for register_entry instruction.
 * This is decoded from migrator_init_payload passed by initializer.
 */
export type RegisterEntryArgs = { entryId: ReadonlyUint8Array };

export type RegisterEntryArgsArgs = RegisterEntryArgs;

export function getRegisterEntryArgsEncoder(): FixedSizeEncoder<RegisterEntryArgsArgs> {
  return getStructEncoder([['entryId', fixEncoderSize(getBytesEncoder(), 32)]]);
}

export function getRegisterEntryArgsDecoder(): FixedSizeDecoder<RegisterEntryArgs> {
  return getStructDecoder([['entryId', fixDecoderSize(getBytesDecoder(), 32)]]);
}

export function getRegisterEntryArgsCodec(): FixedSizeCodec<
  RegisterEntryArgsArgs,
  RegisterEntryArgs
> {
  return combineCodec(
    getRegisterEntryArgsEncoder(),
    getRegisterEntryArgsDecoder(),
  );
}
